export default __webpack_public_path__ + "static/media/storeJS.2ebe06a2.png";